// react
import React from "react";

function ProductTabDescription(props) {
    return (
        <div className="typography">
            <div dangerouslySetInnerHTML={{ __html: props.description }} />
        </div>
    );
}

export default ProductTabDescription;
